import { forwardRef } from "react"
import { ScrollArea } from "@/components/ui/scroll-area"
import { useRemainingHeight } from "@/lib/hooks/useRemainingHeight"
import { DynamicHeightScrollAreaProps } from "."

export const DynamicHeightScrollArea = forwardRef<
    React.ElementRef<typeof ScrollArea>,
    DynamicHeightScrollAreaProps
>(({
    children,
    containerProps = {
        className: 'flex-1'
    },
    scrollAreaProps = {
        className: "pe-4",
        type: "always"
    },
    offset = 0
}, ref) => {
    const {
        height: scrollAreaHeight,
        getHeight: getScrollAreaHeight,
        isLoading: isLoadingScrollAreaHeight
    } = useRemainingHeight(offset);

    return (
        <div ref={getScrollAreaHeight} {...containerProps}>
            {!isLoadingScrollAreaHeight && scrollAreaHeight > 0 && (
                <ScrollArea
                    ref={ref}
                    {...scrollAreaProps}
                    style={{
                        ...scrollAreaProps?.style,
                        height: scrollAreaHeight,
                        // Ensure it doesn't grow beyond calculated height
                        maxHeight: scrollAreaHeight
                    }}
                >
                    {children}
                </ScrollArea>
            )}
        </div>
    );
});

DynamicHeightScrollArea.displayName = "DynamicHeightScrollArea";